export enum FormaPagamentoResgate {
  Unico = 'Unico',
  Parcelado = 'Parcelado',
}
